import type { IconNode } from '../types';

/**
 * @name baby-pacifier
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuMSA3LjRhMS45NSAxLjk1IDAgMCAwIDMuNy0xLjVjLS44LTItMy4yLTMtNS4yLTIuMi0yLjkgMS4yLTQuOCAzLjctNS40IDYuNWExLjk1IDEuOTUgMCAwIDAgMCAzLjZBOS4wNSA5LjA1IDAgMCAwIDcgMTkuNDIiIC8+CiAgPHBhdGggZD0iTTE3LjEgMTkuNGMyLTEuMyAzLjMtMy40IDMuOC01LjZhMiAyIDAgMCAwIDAtMy42IDkuODMgOS44MyAwIDAgMC0zLjItNSIgLz4KICA8cGF0aCBkPSJNOCAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTE2IDEyaC4wMSIgLz4KICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjE2IiByPSIyIiAvPgogIDxwYXRoIGQ9Ik0xMCAxNmgtLjVBMi41IDIuNSAwIDAgMCA3IDE4LjV2MUEyLjUgMi41IDAgMCAwIDkuNSAyMmg1YTIuNSAyLjUgMCAwIDAgMi41LTIuNXYtMWEyLjUgMi41IDAgMCAwLTIuNS0yLjVIMTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/baby-pacifier
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const babyPacifier: IconNode = [
  [
    'path',
    {
      d: 'M10.1 7.4a1.95 1.95 0 0 0 3.7-1.5c-.8-2-3.2-3-5.2-2.2-2.9 1.2-4.8 3.7-5.4 6.5a1.95 1.95 0 0 0 0 3.6A9.05 9.05 0 0 0 7 19.42',
      key: 'jzj46f',
    },
  ],
  [
    'path',
    { d: 'M17.1 19.4c2-1.3 3.3-3.4 3.8-5.6a2 2 0 0 0 0-3.6 9.83 9.83 0 0 0-3.2-5', key: '1w8hyy' },
  ],
  ['path', { d: 'M8 12h.01', key: 'czm47f' }],
  ['path', { d: 'M16 12h.01', key: '1l6xoz' }],
  ['circle', { cx: '12', cy: '16', r: '2', key: '19j1p0' }],
  [
    'path',
    {
      d: 'M10 16h-.5A2.5 2.5 0 0 0 7 18.5v1A2.5 2.5 0 0 0 9.5 22h5a2.5 2.5 0 0 0 2.5-2.5v-1a2.5 2.5 0 0 0-2.5-2.5H14',
      key: '1mnhrg',
    },
  ],
];

export default babyPacifier;
